<!-- TEMPLATE -->
<template>
  <div class="wrapper sidebar-mini" :class="navbarclass">
    <SidebarDashboard />
    <div class="main-panel">
      <Navbar @toggle_sidebar="toggleSideBar" />

      <div class="content" style="padding-top: 0px">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h5 class="title">All notifications</h5>
              </div>
              <div class="card-body">
                <button v-on:click="markAllRead()" class="btn btn-primary">
                  Mark all as read
                </button>
                <v-divider></v-divider>

                <v-list dense>
                  <v-list-item-group v-model="item" color="purple">
                    <template
                      v-for="(item, index) in notifications.slice().reverse()"
                    >
                      <template v-if="item.domain"> 
                        <v-list-item :key="item.id">
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="item.text"
                            ></v-list-item-title>
                            <v-list-item-subtitle
                              v-html="
                                toReadableDate(item.timestamp) +
                                ' - Domain: <b>' +
                                item.original +
                                '</b>'
                              "
                            ></v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-icon
                              v-if="!item.isread"
                              v-on:click="markNotificationRead(item.id)"
                              color="gray"
                              >mdi-checkbox-blank-circle</v-icon
                            >
                            <v-icon v-if="item.isread"
                              >mdi-checkbox-blank-circle-outline</v-icon
                            >
                          </v-list-item-action>
                        </v-list-item>
                      </template>


                      <template v-if="item.email_id">
                        <v-list-item :key="item.id">
                          <v-list-item-content>
                            <v-list-item-title
                              v-html="item.text"
                            ></v-list-item-title>
                            <v-list-item-subtitle
                              v-html="
                                toReadableDate(item.timestamp) +
                                ' - Score: <b>' +
                                item.score + 
                                '</b>'
                                
                              "
                            ></v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-icon
                              v-if="!item.isread"
                              v-on:click="markNotificationRead(item.id)"
                              color="gray"
                              >mdi-checkbox-blank-circle</v-icon
                            >
                            <v-icon v-if="item.isread"
                              >mdi-checkbox-blank-circle-outline</v-icon
                            >
                          </v-list-item-action>
                        </v-list-item>
                      </template>
                      
                      <v-divider
                        v-if="index + 1 < notifications.length"
                        :key="index"
                      ></v-divider>
                    </template>
                  </v-list-item-group>
                </v-list>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterDashboard />
  </div>
</template>

<!-- SCRIPT -->
<script>
import PhishingApi from "../app/phishing-api";
import SidebarDashboard from "./Sidebar.vue";
import Navbar from "./Navbar.vue";
import FooterDashboard from "./Footer.vue";
import _ from "lodash";

export default {
  name: "NotificationsAll",

  data: function () {
    return {
      notificationsList: null,
      bottom: false,
      navbarclass: "",
    };
  },
  computed: {
    notifications: function () {
      return _.sortBy(this.notificationsList, ["timestamp"], ["desc"]);
    },
    notificationsCount: function () {
      return this.notifications ? this.notifications.length : 0;
    },
    newNotifications: function () {
      return this.notifications && this.notifications.length > 0 ? false : true;
    },
  },
  mounted() {
    PhishingApi.getAllNotifications().then(
      (response) => (this.notificationsList = response)
    );
  },
  methods: {
    toggleSideBar(e) {
      if (e) this.navbarclass = "nav-open";
      else this.navbarclass = "";
    },

    bottomVisible() {
      const scrollY = window.scrollY;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const bottomOfPage = visible + scrollY >= pageHeight;
      return bottomOfPage || pageHeight < visible;
    },
    toReadableDate(value) {
      return new Date(value * 1000).toLocaleString();
    },
    getNotifications: function () {
      PhishingApi.getAllNotifications().then(
        (response) => (this.notificationsList = response)
      );
    },
    markAllRead: function () {
      PhishingApi.markAllNotificationsRead()
        .then((response) => this.getNotifications())
        .catch(function (error) {
          console.log("###" + error);
        });
    },
    markNotificationRead: function (id) {
      //this.notificationsList.splice(this.notificationsList.findIndex(item => item.id === id), 1)
      PhishingApi.markNotificationRead(id)
        .then((response) => this.getNotifications())
        .catch(function (error) {
          console.log("###" + error);
        });
    },
  },
  watch: {
    bottom: function () {
      if (this.bottom) console.log("bottom reached");
      //add older notifications
    },
  },
  created() {
    window.addEventListener("scroll", () => {
      this.bottom = this.bottomVisible();
    });
  },
  components: {
    SidebarDashboard,
    Navbar,
    FooterDashboard,
  },
};
</script>

<!-- Style -->
<style>
</style>